module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sv-overlay",
    on: {
      "click": function($event) {
        if ($event.target !== $event.currentTarget) { return null; }
        return _vm.$emit('cancel')
      }
    }
  }, [_c('div', {
    staticClass: "sv-modal"
  }, [_c('div', {
    staticClass: "sv-head"
  }, [_c('div', [_c('div', {
    staticClass: "sv-title"
  }, [_vm._v("Save new version")]), _vm._v(" "), _c('div', {
    staticClass: "sv-subtitle"
  }, [_vm._v("Creating v" + _vm._s(_vm.nextVersionNumber) + " of " + _vm._s(_vm.journeyName))])]), _vm._v(" "), _c('button', {
    staticClass: "sv-close",
    attrs: {
      "title": "Close"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_c('svg', {
    attrs: {
      "width": "16",
      "height": "16",
      "viewBox": "0 0 24 24",
      "fill": "none",
      "stroke": "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round"
    }
  }, [_c('line', {
    attrs: {
      "x1": "18",
      "y1": "6",
      "x2": "6",
      "y2": "18"
    }
  }), _c('line', {
    attrs: {
      "x1": "6",
      "y1": "6",
      "x2": "18",
      "y2": "18"
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "sv-label-row"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "sv-suggest",
    attrs: {
      "type": "button",
      "title": "Suggest a summary with AI",
      "disabled": _vm.loadingSummary
    },
    on: {
      "click": _vm.generateSummary
    }
  }, [_vm._v("\n        " + _vm._s(_vm.loadingSummary ? 'Generating…' : '✨ Suggest summary') + "\n      ")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.notes),
      expression: "notes"
    }],
    ref: "notes",
    staticClass: "sv-notes",
    attrs: {
      "rows": "5",
      "placeholder": _vm.loadingSummary ? 'Generating a summary of your changes…' : 'e.g. Rerouted the in-doubt-testing branch to the Clinic Locator app; added Swahili translations for q1_situation'
    },
    domProps: {
      "value": (_vm.notes)
    },
    on: {
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('cancel')
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.notes = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.summaryError) ? _c('div', {
    staticClass: "sv-error"
  }, [_vm._v("Couldn't generate a summary — write your own, or try again.")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sv-actions"
  }, [_c('button', {
    staticClass: "sv-btn sv-cancel",
    on: {
      "click": function($event) {
        return _vm.$emit('cancel')
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "sv-btn sv-save",
    attrs: {
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v(_vm._s(_vm.saving ? 'Saving…' : 'Save New Version'))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "sv-label"
  }, [_vm._v("What changed in this version? "), _c('span', {
    staticClass: "sv-label-hint"
  }, [_vm._v("(shown in Versions history)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7db7b64d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-journey/journey-flow/SaveVersionModal.vue
// module id = ihDs
// module chunks = 1